import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ClientDetailsState} from './client-details.reducer';

// Selector functions
const clientDetailsData = createFeatureSelector<ClientDetailsState>('ss-cord.client-details');

export const clientDetails = createSelector(
  clientDetailsData,
  (state: ClientDetailsState) => state.clientDetails
);

export const clientStatusFilter = createSelector(
  clientDetailsData,
  (state: ClientDetailsState) => state.clientStatusFilter
);

export const organizationTypeFilter = createSelector(
  clientDetailsData,
  (state: ClientDetailsState) => state.organizationTypeFilter
);

export const clientName = createSelector(
  clientDetailsData,
  (state: ClientDetailsState) => state.clientName
);
